import React from 'react';

// Comps
import {Headings} from '@arctheme-components/elements/Headings/Headings';
import {Link} from '@arctheme-components/elements/Link/Link';
import "./AccountAddress.scss"

const Address = ({
  address,
  isDefault,
  index,
  onClickEdit,
  onClickRemove,
  locales
}: {
  address: any;
  isDefault: boolean;
  index: number;
  onClickEdit: (event: React.ClickEvent<HTMLAnchorElement>, address: any) => void;
  onClickRemove: (event: React.ClickEvent<HTMLAnchorElement>, addressId: number) => void;
  locales: any;
}) => {
  const { firstName, lastName, company, address1, address2, city, province, zip, country } = address;

  locales.defaultAddress = 'Primary Address';
  return (
    <div className='flex flex-col gap-y-3'>
      <div className='flex flex-col gap-y-1'>
        <Headings
          type='h6'
          text={isDefault ? locales.defaultAddress : `Address ${index + 1}`}
          classes='h6'
        />

        <p className='b5 py-[8px] text-[11px]'>
          {(firstName || lastName) && (
            <>
              {firstName} {lastName}
              <br />
            </>
          )}
          {company && (
            <>
              {company}
              <br />
            </>
          )}
          {address1 && (
            <>
              {address1}
              <br />
            </>
          )}
          {address2 && (
            <>
              {address2}
              <br />
            </>
          )}
          {(city || province || zip) && (
            <>
              {city} {province} {zip}
              <br />
            </>
          )}
          {country && (
            <>
              {country}
              <br />
            </>
          )}
        </p>
      </div>
      <div className='flex gap-x-2'>
        <Link
          link={' '}
          classes={`button button-primary w-full`}
          onClick={(e) => onClickEdit(e, address)}
        >
          {locales.edit}
        </Link>
        <Link
          link={' '}
          classes={`button button-primary w-full`}
          onClick={(e) => onClickRemove(e, address.id)}
        >
          {locales.delete}
        </Link>
      </div>
    </div>
  );
};

export default Address;
